import React, { useContext, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import './index.css'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import CommonContext from '@/product/context/common/commonContext'
import { Pagination } from '@material-ui/lab'
import ProductContext from '@/product/context/product/productContext'
import Loaders from '@/custom/components/molecules/Loaders'
import { currencyFormat, maskEmailFront, dateTimeFormatFunction } from '@/custom/common/components'
import AuthContext from '@/product/context/auth/authContext'
import { Button } from '@material-ui/core'
const useStyles = makeStyles((theme, maxWidth) => ({
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%',
        maxWidth: '55rem',
    },
}))

const BidHistory = (props) => {
    const classes = useStyles()
    const [bidPopUp, setBidPopUp] = React.useState({
        popup: false,
        id: 0,
    })
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext

    let [viewProduct, setViewProduct] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const commonContext = useContext(CommonContext)
    const productContext = useContext(ProductContext)
    const { bidHistoryValue, clearBidHistoryValue } = commonContext
    const { search_allbidhistory, getAllBidHistory } = productContext

    const [search, setSearch] = useState({
        limit: 10,
        page: 1,
        id: 0,
    })
    function slicingName(name) {
        if (name) {
            let firstSlice = name?.slice(0, 2)
            let lastSlice = name?.slice(-2)
            let middlename = name?.length - 4
            const stars = '*'.repeat(middlename)
            return firstSlice + stars + lastSlice
        }
        return ''
    }

    useEffect(() => {
        if (bidHistoryValue) {
            setIsLoading(true)
            setSearch({ ...search, id: bidHistoryValue, page: 1 })
            setBidPopUp({ popup: true, id: bidHistoryValue })
            clearBidHistoryValue()
        }
    }, [bidHistoryValue])

    useEffect(() => {
        if (search.id !== 0) {
            setViewProduct([])
            getAllBidHistory(search)
        }
    }, [search])

    const onHandlePage = (event, value) => {
        setSearch({ ...search, page: value })
    }

    useEffect(() => {
        setViewProduct(search_allbidhistory.records.length ? search_allbidhistory.records : [])
        setIsLoading(false)
    }, [search_allbidhistory])

    return (
        <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open={bidPopUp.popup}
            className={`${classes.modal} customModal`}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={bidPopUp.popup}>
                <div className="bidHistoryModal">
                    <div className={classes.paper}>
                        <div className="modal fade show custom-modal">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">{'Offer history'}</h4>
                                        <Button
                                            id="bidHistory_close"
                                            className="close"
                                            onClick={() => setBidPopUp({ popup: false, id: 0 })}
                                        >
                                            <span className="material-icons">close</span>
                                        </Button>
                                    </div>
                                    <div className="modal-body cm-body table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    {/* <th scope="col">{'ID'}</th> */}
                                                    <th scope="col">{'Username'}</th>
                                                    <th scope="col">{'Offer Amount'}</th>
                                                    <th scope="col">{'Time Placed'}</th>
                                                    {/* <th scope="col">{'Status'}</th> */}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan={3} className="loading-cell">
                                                            <Loaders
                                                                name="spinner"
                                                                isLoading={true}
                                                            />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    viewProduct.map((data, index) => (
                                                        <>
                                                            <tr>
                                                                {/* <td>{data.user_id}</td> */}
                                                                <td>
                                                                    {/* {slicingName(
                                                                    data.user_id === user.user_id
                                                                        ? data.first_name +
                                                                              ' ' +
                                                                              data.last_name
                                                                        : maskEmailFront(
                                                                              data.first_name +
                                                                                  ' ' +
                                                                                  data.last_name,
                                                                          ),
                                                                )} */}
                                                                    {slicingName(
                                                                        data.user_id ===
                                                                            user.user_id
                                                                            ? data.username ||
                                                                                  data.first_name ||
                                                                                  '' +
                                                                                      data.last_name ||
                                                                                  ''
                                                                            : maskEmailFront(
                                                                                  data.username ||
                                                                                      data.first_name ||
                                                                                      '' +
                                                                                          data.last_name ||
                                                                                      '',
                                                                              ),
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {data.declined === 1 ? (
                                                                        <del>
                                                                            {currencyFormat(
                                                                                data.proposed_amount,
                                                                            )}
                                                                        </del>
                                                                    ) : (
                                                                        currencyFormat(
                                                                            data.proposed_amount,
                                                                        )
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {dateTimeFormatFunction(
                                                                        data.created_at,
                                                                    )}
                                                                </td>
                                                                {/* <td>
                                                                {data.declined === 1
                                                                    ? 'Retracted'
                                                                    : 'Valid'}
                                                            </td> */}
                                                            </tr>
                                                        </>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        {search_allbidhistory.records.length > 0 && (
                                            <p className="pl-4 maxOfer">
                                                Max Offers are not disclosed.
                                            </p>
                                        )}
                                        {/* <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-3 pagination-wrapper">
                                            <h6>
                                                {'Showing'} {search_allbidhistory.setDisp}
                                                {' of'} {search_allbidhistory.totalRecords}
                                            </h6>
                                            <Pagination
                                                count={Math.ceil(
                                                    search_allbidhistory.totalRecords /
                                                        search.limit,
                                                )}
                                                page={search.page}
                                                onChange={onHandlePage}
                                                siblingCount={3}
                                                showFirstButton
                                                showLastButton
                                                boundaryCount={2}
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default BidHistory
